/*
 * Public API Surface of catalean-localization
 */

export * from './lib/catalean-localization.service';
export * from './lib/catalean-localization.component';
export * from './lib/catalean-localization.module';
